
import XHeader from 'vux/src/components/x-header/index.vue'
import Step from 'vux/src/components/step/step.vue'
import StepItem from 'vux/src/components/step/step-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import Upload from './address/upload'
import Info from './address/info'
import Submit from './address/submit'
export default {
name: 'info',
props: [],
components: {
XHeader,
Step,
StepItem,
XButton,
Flexbox,
FlexboxItem,
Upload,
Info,
Submit
},
data () {
return {
stepList: {
value: 0,
list: [
{
name: '上传凭证'
},
{
name: '填写信息'
},
{
name: '提交审核'
}
]
}
}
},
computed: {
title () {
return this.$route.params.title
},
imgList () {
return this.$store.state.addressFile.filesData
},
isNext () {
let flag = true
let info = this.$store.state.addressInfo

let arr = []
info.forEach(element => {
if (element.value !== [] && element.value !== '') {
arr.push(true)
} else {
arr.push(false)
}
})

for (let i = 0; i < arr.length; i++) {

if (arr[i] === true) {
flag = false
} else {
flag = true
}
}
return flag
}
},
created () {},
mounted () {},
updated () {},
destroyed () {},
watch: {},
methods: {
back () {
setTimeout(() => {
this.$router.back(-1)
}, 300)
},
prev () {
this.stepList.value --
},
next () {
this.stepList.value ++
},
submit () {
setTimeout(() => {
this.$router.push({
name: 'addressResult'
})
}, 300)
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/items/address.vue